import * as React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { DialogContentText, Box, Typography, Stack } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { useBoards } from "../../../../utils/reactQuery/boards";
import arrow from "../../../../styles/svg/arrow.svg";
import "./mergeBoard.scss";
import { useResponsive } from "../../../../hooks/useResponsive";
import { MergeBoards } from "../../../../sevices/apiBoards";
import Loader from "../../../../components/Loader";
import { useWorkflow } from "../../../../utils/reactQuery/workflows";
import useToastPromise from "../../../../hooks/useToast";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { RFHTextField, RHFSelect } from "../../../../components/RFH";

export default function MergeBoard({
  open,
  close,
  currentBoard,
  admin = false,
}) {
  const { boards } = useBoards();
  const queryClient = useQueryClient();
  const isMobile = useResponsive("down", "md");
  const navigate = useNavigate();
  const [targetBoardId, setTagetBoardId] = React.useState(null);
  const [sourceBoardId, setSourceBoardId] = React.useState(
    currentBoard?.data?.data?.responseData?.board_id || null
  );
  const [isloading, setIsLoading] = React.useState(false);
  const [sourceWorkflowId, setSourceWorkflowId] = React.useState(
    currentBoard?.data?.data?.responseData?.workflow_id || null
  );
  const [sourceWorkflowName, setSourceWorkflowName] = React.useState(null);
  const currentBoardName = currentBoard?.data?.data?.responseData?.board_name;
  const { workflows } = useWorkflow();
  const workflowOfSource = workflows?.data?.data?.responseData;
  const { showToastPromise } = useToastPromise();
  const {
    register,
    handleSubmit: updateBoardSubmit,
    watch,
    formState: { },
    getValues,
    autoFocus,
    setValue,
    ...methods
  } = useForm({
    targetStep: "None",
  });

  React.useEffect(() => {
    if (workflowOfSource) {
      setSourceWorkflowName(workflowOfSource);
    }
  }, [workflowOfSource]);

  const selectedTargetStep = watch("targetStep");
  const selectedSourceStep = watch("sourceBoard");

  const { mutate: mergeBoardMutate, isPending } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(MergeBoards, data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: [`boards`],
      });
      setIsLoading(false);
      navigate(`/board/${targetBoardId}`);
      close(false);
      //toast.success(res?.data?.message);
    },
    onError: (error) => {
      console.error("Error Delete Attachments", error);
      setIsLoading(false);
    },
  });

  const workflow = sourceWorkflowName?.filter(
    (item) => item?.workflow_id === sourceWorkflowId
  );

  const allsourceBoards = boards?.data?.data?.responseData
    ?.filter((item) => item.is_archive === false)
    ?.sort((a, b) => {
      return a.board_name.localeCompare(b.board_name);
    });

  // const boardsWithSameWorkFlow = boards?.data?.data?.responseData
  //   ?.filter(
  //     (item) =>
  //       item.workflow_id === sourceWorkflowId &&
  //       item.board_id !== (sourceBoardId || selectedSourceStep) &&
  //       item.is_archive === false
  //   )
  //   ?.sort((a, b) => {
  //     return a.board_name.localeCompare(b.board_name);
  //   });

  const onSubmit = (data) => {
    setTagetBoardId(data?.targetStep);
    setIsLoading(true);

    const newData = { ...data };
    delete newData.targetStep;
    delete newData.prev_step;

    mergeBoardMutate({
      source_board_id: sourceBoardId ?? selectedSourceStep,
      target_board_id: data?.targetStep,
      workflow_step_exchange_id: JSON.stringify(newData),
    });
  };

  const handleClose = () => {
    close(false);
  };

  const targetWorkflowId =  allsourceBoards?.find(
                  (el) => el.board_id === watch("targetStep")
                )?.workflow_id

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <FormDialog
          open={open}
          handleClose={handleClose}
          title={"Merge Board"}
          handleSubmit={updateBoardSubmit(onSubmit)}
          buttonTxt={"Update"}
          width={513}
          disabled={!selectedTargetStep || isloading}
          cancelBtn={true}
          fullWidth={true}
        >
          <div>
            <div className="move-ticket-dialog-content">
              <DialogContentText className="move-ticket-dialog-contentText">
                As the board merges, all tasks will be moved to the target
                board.
              </DialogContentText>
            </div>
            <div className="move-ticket-form-dialogContent">
              <div
                className={
                  isMobile
                    ? "mobile-ticket-reasign-step-container"
                    : "ticket-reasign-step-container"
                }
              >
                <div
                  className={
                    isMobile
                      ? "mobile-current-target-board-name"
                      : "current-target-board-name"
                  }
                >
                  <p>
                    {workflow &&
                    workflow.length > 0 &&
                    workflow[0]?.workflow_name
                      ? workflow[0]?.workflow_name
                      : "Source board"}
                  </p>
                  {admin ? (
                    <div className="initial-step">
                      <RHFSelect
                        sx={{
                          width: isMobile ? "100%" : "180px",
                        }}
                        className="mui-status-field"
                        required
                        // value={getValues(`sourceBoard`)}
                        name={"sourceBoard"}
                      >
                        {allsourceBoards && allsourceBoards?.length > 0 ? (
                          allsourceBoards?.map((option) => (
                            <CustomMenuItem
                              key={`source-${option?.board_id}`}
                              id={`source-${option?.board_id}`}
                              value={option?.board_id}
                              onClick={() =>
                                setSourceWorkflowId(option?.workflow_id)
                              }
                            >
                              {option?.board_name}
                            </CustomMenuItem>
                          ))
                        ) : (
                          <CustomMenuItem>No boards Found</CustomMenuItem>
                        )}
                      </RHFSelect>
                    </div>
                  ) : (
                    <div className="initial-step">
                      <RFHTextField
                        name=""
                        className="mui-status-field"
                        disabled
                        value={currentBoardName}
                      />
                    </div>
                  )}
                </div>

                <img src={arrow} alt="" />
                <div
                  className={
                    isMobile
                      ? "mobile-current-target-board-name"
                      : "current-target-board-name"
                  }
                >
                  <p>Target board</p>
                  <div className="initial-step">
                    <RHFSelect
                      className="mui-status-field merge-board-field"
                      required
                      // value={getValues(`targetStep`)}
                      name={"targetStep"}
                      disabled={admin ? !selectedSourceStep : false}
                    >
                      {allsourceBoards?.length > 0 ? (
                        allsourceBoards
                          ?.filter((item) => item.board_id !== sourceBoardId)
                          ?.map((option) => (
                            <CustomMenuItem
                              key={`target-${option.board_id}`}
                              id={`target-${option.board_id}`}
                              value={option.board_id}
                            >
                              {option.board_name}
                            </CustomMenuItem>
                          ))
                      ) : (
                        <CustomMenuItem>No boards Found</CustomMenuItem>
                      )}
                    </RHFSelect>
                  </div>
                </div>
              </div>
              {targetWorkflowId && sourceWorkflowId !== targetWorkflowId && (
                <Box className="mt-4">
                  <Typography className="weight-700 size-16 text-color">
                    Task Reassignment Step
                  </Typography>
                  <Stack spacing={1}>
                    {sourceWorkflowName
                      ?.find((el) => el.workflow_id == sourceWorkflowId)
                      ?.steps?.map((step, idx) => {
                        setValue(
                          `${step.workflow_step_id}`,
                          sourceWorkflowName?.find(
                            (el) => el.workflow_id == targetWorkflowId
                          ).steps[0]?.workflow_step_id
                        );
                        return (
                          <Box
                            className="board-workflow-change-item"
                            key={`board-workflow-${idx}`}
                          >
                            <RFHTextField
                              sx={{ width: "40%", backgroundColor: "white" }}
                              className="mui-status-field"
                              disabled={true}
                              defaultValue={step?.status || ""}
                              name={"prev_step"}
                            />
                            <img src={arrow} alt="to" className="arrow-img" />

                            <RHFSelect
                              sx={{ width: "40%", backgroundColor: "white" }}
                              className="mui-status-field"
                              required
                              id={`${step.workflow_step_id}`}
                              name={`${step.workflow_step_id}`}
                              defaultValue={
                                sourceWorkflowName?.find(
                                  (el) => el.workflow_id == targetWorkflowId
                                ).steps[0]?.workflow_step_id
                              }
                            >
                              {sourceWorkflowName
                                ?.find(
                                  (el) => el.workflow_id == targetWorkflowId
                                )
                                ?.steps?.map((option) => (
                                  <CustomMenuItem
                                    key={`workflow-option-${option.workflow_step_id}`}
                                    id={`workflow-option-id-${option.workflow_step_id}`}
                                    value={option.workflow_step_id}
                                    className="uppercase"
                                  >
                                    {option.status}
                                  </CustomMenuItem>
                                ))}
                            </RHFSelect>
                          </Box>
                        );
                      })}
                  </Stack>
                </Box>
              )}
            </div>
          </div>
          {isPending && (
            <div className="popup-loader">
              <Loader color={"black"} />
            </div>
          )}
        </FormDialog>
      </FormProvider>
    </React.Fragment>
  );
}
